var poll_default = {
  "fontElementMap": "vjmjO",
  "container": "xkAFF",
  "fullscreen": "_6TqiR",
  "background_overlay": "_8ewcn",
  "with_image": "NLdoE",
  "options": "_4Z541",
  "webview": "BF80H",
  "grid": "cMUG9",
  "option": "_9v6-6",
  "cta_button": "lQYXF",
  "add_option": "kIbM2",
  "see_more": "a7eD6",
  "list": "SodQv",
  "column": "_8KCoz",
  "additional_note": "_8R0QX",
  "spinner": "-ZXZY",
  "spin": "pc33l",
  "shown": "luvgr",
  "error": "aT5Pj"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
